/**
 * Tenant: Mimu Garten (mimugarten.nl/configurator)
 *
 * Duitse markt, met NL als tweede taal. Zelfde product als Domi Veranda, andere
 * scene, andere prijzen, ander merk.
 *
 * LET OP bij het omzetten naar de hub: zet 'transport' pas op 'signalr' als de
 * MimuGarten-renderer met RequestHandlerV2 draait en zich als tenant
 * 'mimugarten' meldt. Zie docs/MIGRATIE_MIMUGARTEN.md.
 */
const config = {
    id: 'mimugarten',
    naam: 'Mimu Garten',

    render: {
        transport: 'signalr',

        // Draait op de gezamenlijke worker, die het logo per render omwisselt.
        brand: 'mimugarten',

        // Deze renderer kent de 17-velds request-string, dus eerst een snelle
        // preview en daarna stil de mooie versie.
        tiers: {
            fast: { width: 800, height: 800, samples: 5 },
            hq: { width: 1600, height: 1600, samples: 15 },
        },
    },

    php: {
        base: 'https://mimugarten.nl/configurator/phpfiles',
        timeoutMs: 120000,
        pollFastMs: 100,
        pollSlowMs: 5000,
    },

    hub: {
        // Klaargezet voor de migratie; wordt pas gebruikt als transport op
        // 'signalr' gaat. De hub accepteert elke tenantId, dus aan die kant
        // hoeft er niets te gebeuren.
        url: 'https://ws.cloudrenderer.eu:8100/chat-hub',
        // Beide merken draaien op EEN worker, dus op EEN tenant. Deze naam
        // bepaalt bij wie de aanvraag terechtkomt; het merk bepaalt het logo.
        tenant: 'veranda',
        // Beide merken delen de tenant 'veranda'. Deze naam staat in de URL van
        // elk beeld, dus hij draagt bewust geen klantnaam.
        fileBase: 'https://ws.cloudrenderer.eu:8100/file/veranda',
        timeoutMs: 120000,
    },

    product: {
        // Mimu Garten voert pergamon wel in meerdere kleuren.
        pergamonForcesColor: null,
    },

    tracking: {
        metaPixelLead: true,
        googleAdsConversion: 'AW-18058170287/jCCRCNOloaQcEK-f56JD',
    },

    i18n: {
        storageKey: 'mimu_lang',
        supported: ['nl', 'de'],
        default: 'de',
        // mimugarten.nl heeft DE op de root en NL onder /nl/.
        scheme: 'nl-prefix',
        host: 'mimugarten.nl',
        home: { nl: 'https://mimugarten.nl/nl/', de: 'https://mimugarten.nl/' },
        logo: { nl: './assets/images/mimugarten-logo.png', de: './assets/images/mimugarten-logo.png' },
        flagExt: 'svg',
        flagBase: 'https://cdn.weglot.com/flags/circle/',
    },

    /**
     * Demo-stand: `python build.py mimugarten --demo`.
     * Draait tegen de TESTHUB (poort 8300) onder een eigen tenant-naam, zodat een
     * proef nooit op de wachtrij van een klant terechtkomt. Wil je hier een echte
     * render uit zien komen, dan moet er een worker op die tenant meeluisteren.
     */
    demo: {
        id: 'veranda-demo',
        // Beide merken draaien in de demo op DEZELFDE testworker; het merk
        // bepaalt welk logo de renderer in de scene zet.
        render: { transport: 'signalr', tiers: null, brand: 'mimugarten' },
        hub: {
            url: 'https://ws.cloudrenderer.eu:8300/chat-hub',
            fileBase: 'https://ws.cloudrenderer.eu:8300/file/veranda-demo',
            timeoutMs: 60000,
        },
    },
};

export default config;
